export default function IconSorting({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M11.5 0.999999L13 0.999999L13 23L11.5 23L11.5 0.999999ZM19 7.28516L20.5 7.28516L20.5 23L19 23L19 7.28516ZM4 13.5713L5.5 13.5713L5.5 23L4 23L4 13.5713Z"
        fill="currentColor"
      />
    </svg>
  );
}
